import React,{useEffect} from 'react';
import { connect } from 'react-redux';
// import { testUpdateFloorMarkersInDatastore } from '../../../../store/actions/datastoreActions';
import $ from 'jquery';
const mapScale = (number, inMin, inMax, outMin, outMax) => {
    return (number - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}

const ElevationMarkers = (props) => {
    useEffect(() => {    
        $('[data-toggle="tooltip"]').tooltip();
     });
    const { actualScalingFactor, handleSetMarkerId, scalingFactor } = props;
    const floorMarkers = props.floorMarkers ?? [];
    const pinFactor = 0 * mapScale(scalingFactor, 1, 5, 5, 7)
    const pinFactor2 = 0 * mapScale(scalingFactor, 1, 5, 5, 7)

    const r = 2
    const br = 15 - pinFactor2
    const wr = 10 - pinFactor2
    const base = 16 - pinFactor
    const height = 22 - pinFactor

    const markerList = (floorMarkers.length ?
        (
            floorMarkers.map(eachMarker => {
                const cx = eachMarker.coordinates[0] / actualScalingFactor;
                const cy = eachMarker.coordinates[1] / actualScalingFactor;
                return (
                    <g key={eachMarker.markerid} onClick={() => { handleSetMarkerId(eachMarker.markerid) }} role="button" data-toggle="tooltip" data-placement="top" title={eachMarker.title}>
                        <path d={`M ${cx} ${cy} l -${base / 2} -${height} l ${base} 0 z`} fill="black" />

                        <circle cx={cx} cy={cy - height - br + 4} r={br} fill="black" />

                        {eachMarker.identifier === "0" ?
                            <React.Fragment>
                                <circle cx={cx} cy={cy - height - br + 4} r={wr} fill="white" />
                                <circle cx={cx} cy={cy - height - br + 4} r={wr * 0.4} fill={eachMarker.isDeadlineComplete ? "green" : "red"} />
                            </React.Fragment>
                            :
                            <React.Fragment/>
                            // <rect x={cx - wr + 1} y={cy - height - br - wr + 5} width={wr * 2 - 2} height={wr * 2 - 2} fill="white" />
                        }

                        <circle cx={cx} cy={cy} r={r} fill="red" />
                    </g>
                );
            })
        ) : (
            <React.Fragment></React.Fragment>
        )
    )

    return (
        <React.Fragment>
            {markerList}
        </React.Fragment>
    );
}

const mapStateToProps = (state) => {
    return {
        proid: state.project.proid,
        floorMarkers: state.firestore.ordered.FloorMarkers,
    }
}

export default connect(mapStateToProps)(ElevationMarkers);
